/** FOUNDER-DASHBOARD-IMPLEMENTATION-000005 — 24 Hour Sales Pulse contracts. */

export type PulseMetricId = 'gmv' | 'orders' | 'units';

export type PulseSeriesId =
  | 'today'
  | 'yesterday'
  | 'avg7'
  | 'avg15'
  | 'avg30';

export type PulseSeriesDef = {
  id: PulseSeriesId;
  label: string;
  kind: 'bars' | 'line';
  color: string;
  defaultOn: boolean;
};

export type HourBucket = {
  hour: number;
  label: string;
  /** When no orders land in this hour, zeros are real counts — not invented KPIs. */
  gmv: number | null;
  orders: number;
  units: number | null;
  multiCurrency: boolean;
};

export type HourPoint = {
  hour: number;
  label: string;
  today: HourBucket;
  yesterday: HourBucket;
  avg7: { gmv: number | null; orders: number | null; units: number | null };
  avg15: { gmv: number | null; orders: number | null; units: number | null };
  avg30: { gmv: number | null; orders: number | null; units: number | null };
};

export type SalesPulseModel = {
  loadedAt: string;
  connectionId: string | null;
  marketplaceId?: string;
  sellerRef?: string;
  dayIso: string;
  dayLabel: string;
  points: HourPoint[];
  /** True when today has ≥1 order header in the LIVE scan window. */
  hasTodayData: boolean;
  truncated: boolean;
  currency?: string;
  error: string | null;
  sourceNote: string;
};

export const PULSE_SERIES: PulseSeriesDef[] = [
  {
    id: 'today',
    label: 'Today',
    kind: 'bars',
    color: 'var(--shell-accent)',
    defaultOn: true,
  },
  {
    id: 'yesterday',
    label: 'Yesterday',
    kind: 'line',
    color: '#38bdf8',
    defaultOn: true,
  },
  {
    id: 'avg7',
    label: '7-day avg',
    kind: 'line',
    color: '#a78bfa',
    defaultOn: false,
  },
  {
    id: 'avg15',
    label: '15-day avg',
    kind: 'line',
    color: '#34d399',
    defaultOn: false,
  },
  {
    id: 'avg30',
    label: '30-day avg',
    kind: 'line',
    color: '#94a3b8',
    defaultOn: false,
  },
];
